/** Portal marketing route defaults — admin CMS seed. */
export const SITE_PAGE_DEFAULTS = [
  { slug: "site", path: "/site", title: "Destinasyon 360 Site", subtitle: "Karadeniz keşif platformu tanıtım sayfası." },
  { slug: "about", path: "/about", title: "Hakkımızda", subtitle: "Destinasyon 360’ın hikâyesi ve vizyonu." },
  { slug: "contact", path: "/contact", title: "İletişim", subtitle: "Destek ve iş ortaklığı iletişim bilgileri." },
  { slug: "destination", path: "/destination", title: "Destinasyonlar", subtitle: "Karadeniz destinasyonlarını keşfedin." },
  { slug: "destination-2", path: "/destination-2", title: "Destinasyonlar (Alternatif)", subtitle: "Alternatif destinasyon listesi." },
  { slug: "destination-details", path: "/destination-details", title: "Destinasyon Detayı", subtitle: "Örnek destinasyon detay içeriği." },
  { slug: "faq", path: "/faq", title: "Sık Sorulan Sorular", subtitle: "Platform, üyelik ve tanıtım hakkında SSS." },
  { slug: "gallery", path: "/gallery", title: "Galeri", subtitle: "Karadeniz’den seçilmiş görseller." },
  { slug: "index-2", path: "/index-2", title: "Ana Sayfa Alternatif 2", subtitle: "Pazarlama ana sayfa varyasyonu." },
  { slug: "index-3", path: "/index-3", title: "Ana Sayfa Alternatif 3", subtitle: "Pazarlama ana sayfa varyasyonu." },
  { slug: "index-4", path: "/index-4", title: "Ana Sayfa Alternatif 4", subtitle: "Pazarlama ana sayfa varyasyonu." },
  { slug: "news", path: "/news", title: "Haberler", subtitle: "Duyuru ve haber listesi." },
  { slug: "news-details", path: "/news-details", title: "Haber Detayı", subtitle: "Örnek haber detay içeriği." },
  { slug: "news-grid", path: "/news-grid", title: "Haberler (Izgara)", subtitle: "Haber ızgara görünümü." },
  { slug: "team", path: "/team", title: "Ekip", subtitle: "Ekip ve rehberler." },
  { slug: "team-details", path: "/team-details", title: "Ekip Detayı", subtitle: "Örnek ekip üyesi detayı." },
  { slug: "tour-details", path: "/tour-details", title: "Tur Detayı", subtitle: "Örnek tur detay içeriği." },
  { slug: "tour-grid", path: "/tour-grid", title: "Turlar (Izgara)", subtitle: "Tur listesi ızgara görünümü." },
  { slug: "tour-list", path: "/tour-list", title: "Turlar (Liste)", subtitle: "Tur listesi." },
  { slug: "tour-no-sidebar", path: "/tour-no-sidebar", title: "Turlar (Kenar çubuksuz)", subtitle: "Tam genişlik tur listesi." },
  { slug: "tour-sidebar", path: "/tour-sidebar", title: "Turlar (Kenar çubuklu)", subtitle: "Kenar çubuklu tur listesi." },
];

export const seedSitePages = SITE_PAGE_DEFAULTS.map((page, index) => ({
  id: page.slug,
  slug: page.slug,
  path: page.path,
  title: page.title,
  subtitle: page.subtitle,
  seoDescription: page.subtitle,
  heroImage: "",
  bodyHtml: "",
  sections: [
    {
      title: "Genel bakış",
      paragraphs: [
        `${page.title} içeriğini admin panelinden düzenleyebilirsiniz. Bu metin varsayılan bir başlangıç içeriğidir.`,
      ],
      items: [],
    },
  ],
  sortOrder: index + 1,
  isPublished: true,
  createdAt: "2026-11-02T12:00:00.000Z",
  updatedAt: "2026-11-02T12:00:00.000Z",
  deletedAt: null,
}));
